export const required = (value: any) =>
  !value ||
  (Array.isArray(value) && !value.length) ||
  (value.label && !value.value)
    ? 'Required'
    : undefined;

export const isValidMoney = (value: string) =>
  !value ||
  value === '_' ||
  /^\$?[0-9]?[0-9,]*[0-9]\.?[0-9]{0,2}$/i.test(value);

export const validateUrl = (url: string) => {
  if (!url) return false;
  const re =
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
  return re.test(url);
};

export const validateLandlineOrMobile = (value: string) => {
  if (!value) return false;
  const re =
    /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/;
  return re.test(value);
};

export const getMoneyNumberFromString = (str: string) => {
  const val = (str || '')
    .toString()
    .trim()
    .replace(/\$/g, '')
    .replace(/\,/g, '');
  return parseFloat(val);
};
